"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _withContainer = require("../../withContainer");
require("./Content.scss");
var Content = function Content(_ref) {
  var animationType = _ref.animationType,
    closeButtonRef = _ref.closeButtonRef,
    className = _ref.className,
    content = _ref.content,
    closeButton = _ref.closeButton,
    modalRef = _ref.modalRef,
    dataAttributes = _ref.dataAttributes,
    onClose = _ref.onClose,
    onClickAway = _ref.onClickAway,
    onKeyDown = _ref.onKeyDown,
    role = _ref.role,
    styleType = _ref.styleType,
    text = _ref.text,
    type = _ref.type;
  var rootClassName = (0, _classnames["default"])('cds-ModalCover', _withContainer.animationTypeClass[animationType], _withContainer.styleTypeClass[styleType], _withContainer.typeClass[type], className);
  var body = document.body;
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("aside", {
    "aria-label": text.ariaLabel,
    "aria-modal": "true",
    className: rootClassName,
    onKeyDown: onKeyDown,
    onMouseDown: onClickAway,
    role: role,
    tabIndex: -1
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: "cds-Modal",
    ref: modalRef
  }), /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
    "aria-labelledby": "close-modal",
    buttonRef: closeButtonRef,
    className: "cds-Modal-CloseButton ".concat(_withContainer.closeButtonClass[closeButton]),
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.close,
    onClick: onClose,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost
  }), content)), body);
};
exports.Content = Content;